import './bootstrap';

import Alpine from 'alpinejs';
import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";
import WalletLink from "walletlink";

// Import Alpine components
import mint from './components/mint.js'

// Set global Alpine instance
window.Alpine = Alpine;

Alpine.store('provider', {
    web3: null,
    web3Modal: null,
    provider: null,
    accounts: [],
    walletAddress: null,
    networkId: null,
    networkData: null,


    async connect() {
        const infuraId = "a5858d472b4849a3be9096533cf7ed6f";
        const providerOptions = {
            walletconnect: {
                package: WalletConnectProvider,
                options: {
                    infuraId
                }
            },
            'custom-walletlink': {
                display: {
                    logo: 'https://play-lh.googleusercontent.com/PjoJoG27miSglVBXoXrxBSLveV6e3EeBPpNY55aiUUBM9Q1RCETKCOqdOkX2ZydqVf0',
                    name: 'CoinBase',
                    description: 'Scan with WalletLink to connect',
                },
                options: {
                    appName: 'Coinbase', // Your app name
                    networkUrl: 'https://mainnet.infura.io/v3/' + infuraId,
                    chainId: 1,
                },
                package: WalletLink,
                connector: async (_, options) => {
                    const { appName, networkUrl, chainId } = options
                    const walletLink = new WalletLink({
                        appName
                    });
                    const provider = walletLink.makeWeb3Provider(networkUrl, chainId);
                    await provider.enable();
                    return provider;
                },
            },
        };

        this.web3Modal = new Web3Modal({
            cacheProvider: false, // optional
            providerOptions, // required
            disableInjectedProvider: false, // optional. For MetaMask / Brave / Opera.
        });

        try {
            this.provider = await this.web3Modal.connect();
        } catch (e) {
            console.log("Could not get a wallet connection", e);
            return;
        }

        this.getAccountData();

        // Subscribe to accounts change
        this.provider.on("accountsChanged", (accounts) => {
            this.getAccountData();
        });

        // Subscribe to chainId change
        this.provider.on("chainChanged", (chainId) => {
            this.getAccountData();
        });

        // Subscribe to networkId change
        this.provider.on("networkChanged", (networkId) => {
            this.getAccountData();
        });
    },

    async getAccountData() {
        this.web3 = new Web3(this.provider);

        this.accounts = await this.web3.eth.getAccounts()
        this.walletAddress = this.accounts[0]
    },

    async disconnect() {
        // TODO: Which providers have close method?
        if (this.provider.close) {
            await this.provider.close();
            // If the cached provider is not cleared,
            // WalletConnect will default to the existing session
            // and does not allow to re-scan the QR code with a new wallet.
            // Depending on your use case you may want or want not his behavir.
            await this.web3Modal.clearCachedProvider();
            this.provider = null;
        }

        this.walletAddress = null;
    },

    isConnected() {
        return this.walletAddress;
    }
})

Alpine.effect(() => {
    let store = Alpine.store('provider')
    // store.connect();
    console.log(store.isConnected());
})

// Create data components
Alpine.data('mint', mint)

// Start Alpine
Alpine.start();
